/**
 * Appends an 's' to a string based on the quantity.
 * @param word The string to use if the quantity is 1.
 * @param quantity The quantity that will determine the string returned.
 * @param pluralizedWord The string to use if the quantity is not 1, and adding an 's' to the singular version is not acceptable.
 * @returns The context-appropriate string.
 */
export function pluralize(
  word: string,
  quantity: number,
  pluralizedWord?: string,
) {
  return quantity === 1 ? word : pluralizedWord || `${word}s`
}
